import { render, staticRenderFns } from "./FileDisplay.vue?vue&type=template&id=bc079e4c"
import script from "./FileDisplay.vue?vue&type=script&lang=js"
export * from "./FileDisplay.vue?vue&type=script&lang=js"
import style0 from "./FileDisplay.vue?vue&type=style&index=0&id=bc079e4c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports